import { createHashRouter, RouterProvider } from 'react-router-dom';
import { NavigationProviderProps } from './interfaces/navigation.interface';

export const NavigationProvider: React.FC<NavigationProviderProps> = ({
    children,
    routes,
}) => {
    const router = createHashRouter(routes);

    return (
        <>
            {children}
            <RouterProvider router={router} />
        </>
    );
};
